export default {
  CGU: 'https://olino.fr/cgu',
  POLITIQUE_CONFIDENTIALITE: 'https://olino.fr/politique-de-confidentialite',
}
